var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.18951H20.7778M9.66667 16.9542V9.89539M14.1111 16.9542V9.89539M16.3333 21.6601H7.44444C6.21715 21.6601 5.22222 20.6066 5.22222 19.3072V6.36598C5.22222 5.71623 5.71968 5.18951 6.33333 5.18951H17.4444C18.0581 5.18951 18.5556 5.71623 18.5556 6.36598V19.3072C18.5556 20.6066 17.5606 21.6601 16.3333 21.6601ZM9.66667 5.18951H14.1111C14.7248 5.18951 15.2222 4.66278 15.2222 4.01304V2.83657C15.2222 2.18682 14.7248 1.6601 14.1111 1.6601H9.66667C9.05302 1.6601 8.55556 2.18682 8.55556 2.83657V4.01304C8.55556 4.66278 9.05302 5.18951 9.66667 5.18951Z",
    stroke: "#434343",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.238977f875a1daf4cf886f4639ae1d4f.svg";
export { ForwardRef as ReactComponent };